<template>
    <section>
        <div class="row justify-content-end">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'tryout/offline/index' }">
                                Tryout
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            {{ tryout.name }}
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-4">
                <h3>Tryout Offline</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-8 col-sm-12">
                <div class="card shadow-sm mb-4 border-0">
                    <div class="card-header background-primary">
                        <div class="row justify-content-end">
                            <div class="col">
                                &nbsp;
                            </div>
                            <div class="ml-auto col-auto" v-if="roleElligibleModified()">
                                <router-link v-bind:to="{ name: 'tryout/offline/edit', params: {id: tryout.id} }" class="btn btn-link h4 p-0 my-0 mr-2">
                                    Edit
                                </router-link>
                                <button class="btn btn-link h4 p-0 m-0" v-on:click="modal.remove = true">
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="card-title text-muted mb-0">
                            Nama TO:
                        </div>
                        <p class="mb-2 text-loading">
                            {{ tryout.name }}
                        </p>
                        <div class="card-title text-muted mb-0">
                            Kelas:
                        </div>
                        <p class="mb-2">
                            <ul class="mb-0 pl-3">
                                <li v-for="grade in tryout.grades" v-bind:key="grade.id" class="text-loading mb-1">{{ grade.name }}</li>
                            </ul>
                        </p>
                        <template v-if="tryout.tryoutGroups.length">
                            <template v-for="tryoutGroup in tryout.tryoutGroups">
                                <div class="card-title text-muted mb-0 text-loading">
                                    <span v-if="tryoutGroup.groupSubject">{{ tryoutGroup.groupSubject.name }} {{ tryoutGroup.code }}:</span>
                                </div>
                                <p class="mb-1">
                                    <ul class="mb-0 pl-3">
                                        <li v-for="tryoutSubject in tryoutGroup.tryoutSubjects" v-bind:key="tryoutSubject.id">
                                            <div class="row align-items-center">
                                                <div class="col">
                                                    <router-link v-bind:to="{name: 'tryout/offline/question/view', params: {id: tryout.id, tryoutSubjectID: tryoutSubject.id}}" class="text-loading mb-2" v-if="tryoutSubject.subject">
                                                        {{ tryoutSubject.subject.name }} {{ tryoutSubject.code }}
                                                    </router-link>
                                                    - {{ tryoutSubject.currentTotal }}/{{ tryoutSubject.totalQuestion }} Soal
                                                </div>
                                                <div class="col-auto ml-auto align-self-center">
                                                    <template v-if="roleElligibleModified()">
                                                        <input v-bind:id="'file-answer-key-' + tryoutSubject.id" type="file" class="form-control" v-on:change="uploadAnswerKey($event, tryoutSubject)" placeholder="Choose File" accept=".xlsx, .xls, .csv"/>
                                                        <label v-bind:for="'file-answer-key-' + tryoutSubject.id" class="btn btn-sm btn-danger mr-1">
                                                            Upload Kunci Jawaban
                                                        </label>
                                                    </template>
                                                    <template v-else>
                                                        <span class="h4 text-danger font-weight-bold mr-1">
                                                            Kunci Jawaban
                                                        </span>
                                                    </template>
                                                    <i v-if="tryoutSubject.currentTotal > 0" class="fa fa-lg text-success fa-check-circle"></i>
                                                    <i v-else class="fa fa-lg text-danger fa-times-circle"></i>
                                                </div>
                                                <div class="col-auto ml-auto align-self-center">
                                                    <template v-if="roleElligibleModified()">
                                                        <input v-bind:id="'file-student-answer-' + tryoutSubject.id" type="file" class="form-control" v-on:change="uploadStudentAnswer($event, tryoutSubject)" placeholder="Choose File" accept=".xlsx, .xls, .csv"/>
                                                        <label v-bind:for="'file-student-answer-' + tryoutSubject.id" class="btn btn-sm btn-danger mr-1">
                                                            Upload Jawaban Siswa
                                                        </label>
                                                    </template>
                                                    <template v-else>
                                                        <span class="h4 text-danger font-weight-bold mr-1">
                                                            Jawaban Siswa
                                                        </span>
                                                    </template>
                                                    <i v-if="tryoutSubject.hasStudentAnswer" class="fa fa-lg text-success fa-check-circle"></i>
                                                    <i v-else class="fa fa-lg text-danger fa-times-circle"></i>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </p>
                            </template>
                        </template>
                        <template v-else>
                            <div class="card-title text-muted mb-0">
                                Mata Pelajaran:
                            </div>
                            <p class="mb-2">
                                <ul class="mb-0 pl-3">
                                    <li v-for="tryoutSubject in tryout.tryoutSubjects" v-bind:key="tryoutSubject.id">
                                        <div class="row align-items-center">
                                            <div class="col">
                                                <router-link v-bind:to="{name: 'tryout/offline/question/view', params: {id: tryout.id, tryoutSubjectID: tryoutSubject.id}}" class="text-loading mb-2">
                                                    {{ tryoutSubject.subject.name }} {{ tryoutSubject.code }}
                                                </router-link>
                                                - {{ tryoutSubject.currentTotal }}/{{ tryoutSubject.totalQuestion }} Soal
                                            </div>
                                            <div class="col-auto ml-auto align-self-center">
                                                <template v-if="roleElligibleModified()">
                                                    <input v-bind:id="'file-answer-key-' + tryoutSubject.id" type="file" class="form-control" v-on:change="uploadAnswerKey($event, tryoutSubject)" placeholder="Choose File" accept=".xlsx, .xls, .csv"/>
                                                    <label v-bind:for="'file-answer-key-' + tryoutSubject.id" class="btn btn-sm btn-danger mr-1">
                                                        Upload Kunci Jawaban
                                                    </label>
                                                </template>
                                                <template v-else>
                                                    <span class="h4 text-danger font-weight-bold mr-1">
                                                        Kunci Jawaban
                                                    </span>
                                                </template>
                                                <i v-if="tryoutSubject.currentTotal > 0" class="fa fa-lg text-success fa-check-circle"></i>
                                                <i v-else class="fa fa-lg text-danger fa-times-circle"></i>
                                            </div>
                                            <div class="col-auto ml-auto align-self-center">
                                                <template v-if="roleElligibleModified()">
                                                    <input v-bind:id="'file-student-answer-' + tryoutSubject.id" type="file" class="form-control" v-on:change="uploadStudentAnswer($event, tryoutSubject)" placeholder="Choose File" accept=".xlsx, .xls, .csv"/>
                                                    <label v-bind:for="'file-student-answer-' + tryoutSubject.id" class="btn btn-sm btn-danger mr-1">
                                                        Upload Jawaban Siswa
                                                    </label>
                                                </template>
                                                <template v-else>
                                                    <span class="h4 text-danger font-weight-bold mr-1">
                                                        Jawaban Siswa
                                                    </span>
                                                </template>
                                                <i v-if="tryoutSubject.hasStudentAnswer" class="fa fa-lg text-success fa-check-circle"></i>
                                                <i v-else class="fa fa-lg text-danger fa-times-circle"></i>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </p>
                        </template>
                        <template v-if="roleElligibleModified()">
                            <hr />
                            <div class="card-title mb-0 text-right" >
                                <a v-bind:href="'/static/template/data-sample-tryout-answer-key.csv?timestamp=' + $moment(new Date).format('X')" class="mb-0 small mr-3">
                                    <i class="fa fa-download"></i> Template Kunci Jawaban
                                </a>
                                <a v-bind:href="'/static/template/data-sample-tryout-student-answer.csv?timestamp=' + $moment(new Date).format('X')" class="mb-0 small">
                                    <i class="fa fa-download"></i> Template Jawaban Siswa
                                </a>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-8 col-sm-12 mb-4">
                <template v-if="roleElligibleModified()">
                    <div class="row justify-content-sm-between justify-content-center">
                        <div class="col-auto mb-1">
                            <button class="btn btn-sm btn-outline-danger px-5" type="button" v-on:click="calculate()">
                                Kalkulasi Jawaban Siswa
                            </button>
                        </div>
                        <template v-if="tryout.tryoutGroups.length">
                            <div class="col-auto">
                                <button class="btn btn-sm btn-danger mr-1 px-5" type="button" v-on:click="modal.upload = true">
                                    Upload Nilai Siswa
                                </button>
                            </div>
                        </template>
                    </div>
                </template>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col">
                        <h3>Nilai Siswa</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mb-4">
                        <div id="table-primary" class="table-responsive" v-dragscroll="!isMobile()">
                            <table class="table">
                                <thead>
                                    <tr class="text-danger font-weight-bold">
                                        <th>
                                            Nama Lengkap
                                        </th>
                                        <th>
                                            Nomor Peserta BTA
                                        </th>
                                        <th v-for="tryoutSubject in tryoutSubjects" v-if="tryoutSubject.subject">
                                            <div>Nilai</div>
                                            {{ tryoutSubject.subject.name }}
                                        </th>
                                        <th>
                                            Total
                                        </th>
                                        <th>
                                            Peringkat
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="shadow-sm" v-for="student in students" v-bind:key="student.userID">
                                        <td>
                                            <template v-if="student.user">
                                                <router-link v-bind:to="{name: 'student/view', params: {id: student.userID}}" class="text-loading" v-if="profile.isAdmin || (profile.isEmployee && (profile.employee.isDirector || profile.employee.isManager))">{{ student.user.name }}</router-link>
                                                <span class="text-loading" v-else>{{ student.user.name }}</span>
                                            </template>
                                        </td>
                                        <td>
                                            <span class="text-loading">{{ student.identity }}</span>
                                        </td>
                                        <td v-for="tryoutSubject in tryoutSubjects">
                                            <span class="text-loading">{{ score(student, tryoutSubject) }}</span>
                                        </td>
                                        <td>
                                            <span class="text-loading">{{ student.totalScore }}</span>
                                        </td>
                                        <td>
                                            <span class="text-loading">{{ student.rank }}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col-12 mb-4">
                        <nav class="float-right">
                            <paginate v-model="page" next-text="<i class='fa fa-chevron-right'></i>" prev-text="<i class='fa fa-chevron-left'></i>" v-bind:click-handler="paginate" v-bind:page-count="pageCount" container-class="pagination pagination-sm flex-wrap" page-class="page-item" prev-class="page-item" v-bind:next-class="'page-item'" page-link-class="page-link" prev-link-class="page-link" next-link-class="page-link" v-bind:hide-prev-next="true">
                            </paginate>
                        </nav>
                    </div>
                </div>
            </div>
        </div>

        <b-modal v-if="roleElligibleModified()" v-model="modal.remove" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Warning!!
                </h4>
            </template>
            <div class="container text-center">
                <div class="row">
                    <div class="col-12">
                        <h4 class="font-weight-medium mb-4">Apa yakin mau menghapus Tryout Offline ini? Karena jika sudah terhapus data tidak dapat dikembalikan</h4>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-outline-danger btn-sm px-5" v-on:click="remove">
                            Ya
                        </button>
                        <button class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modal.remove = false">
                            Batal
                        </button>        
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal v-if="tryout.tryoutGroups.length && roleElligibleModified()" v-model="modal.upload" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Upload Nilai Siswa
                </h4>
            </template>
            <div class="container">
                <form v-on:submit.prevent="uploadStudentScore()">
                    <div class="row">
                        <div class="col-12 mb-4">
                            <div class="row mb-2 align-items-center">
                                <div class="col text-right">
                                    <a v-bind:href="'/static/template/data-sample-group-score.csv?timestamp=' + $moment(new Date).format('X')" class="mb-0 small">
                                        Download Template
                                    </a>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Jenis Penilaian</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <select v-model="form.upload.tryoutGroupID" class="form-control form-control-sm" required>
                                        <option disabled value="" selected>Pilih Jenis Penilaian...</option>
                                        <option v-for="tryoutGroup in tryout.tryoutGroups" v-bind:value="tryoutGroup.id" v-bind:key="tryoutGroup.id" v-if="tryoutGroup.groupSubject">{{ tryoutGroup.groupSubject.name }} {{ tryoutGroup.code }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Upload File</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <input id="file-student-score" type="file" class="form-control" v-on:change="fileStudentScore($event)" placeholder="Choose File" accept=".xlsx, .xls, .csv" required/>
                                    <label for="file-student-score" class="form-control form-control-sm text-truncate">
                                        <button type="button" class="btn btn-danger font-weight-bold">
                                            Choose File
                                        </button> 
                                        {{ form.upload['group-score'].name }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center">
                            <button type="submit" class="btn btn-danger btn-sm px-5">
                                Submit
                            </button>
                            <button class="btn btn-outline-danger btn-sm px-5 ml-3" type="button" v-on:click="modal.upload = false">
                                Batal
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import { dragscroll } from 'vue-dragscroll';
    import Paginate from 'vuejs-paginate';
    /**
     * @param {Object} tryout
     */
    export default {
        name: "TryoutOfflineView",
        directives: {dragscroll},
        components: {
            Paginate
        },
        computed: mapState([
            'profile'
        ]),
        data() {
            return {
                form: {
                    upload: {
                        tryoutGroupID: '',
                        'group-score': ''
                    }
                },
                tryout: {tryoutGroups: [{}, {}, {}], grades: [{}, {}, {}]},
                tryoutSubjects: [],
                students: [],
                modal: {
                    remove: false,
                    upload: false
                },
                pageCount: 0,
                page: 1
            };
        },
        methods: {
            uploadAnswerKey(event, tryoutSubject) {
                var input = event.currentTarget;
                if (input.files && input.files[0]) {
                    var formData = new FormData();
                    formData.set('tryoutSubjectID', tryoutSubject.id);
                    formData.set('question', input.files[0]);
                    this.axios.post(process.env.API_URL + '/question/upload', formData).then(response => {
                        if (response.data.status) {
                            this.$toastr('success', response.data.message, 'Success');
                            this.fetchTryout();
                        } else {
                            this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                        }
                    });
                } else {
                    this.$toastr('warning', 'Please select file', 'Warning');
                }
            },
            uploadStudentAnswer(event, tryoutSubject) {
                var input = event.currentTarget;
                if (input.files && input.files[0]) {
                    var formData = new FormData();
                    formData.set('tryoutSubjectID', tryoutSubject.id);
                    formData.set('student-answer', input.files[0]);
                    this.axios.post(process.env.API_URL + '/question/upload-student-answer', formData).then(response => {
                        if (response.data.status) {
                            this.$toastr('success', response.data.message, 'Success');
                            this.fetchTryout();
                        } else {
                            this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                        }
                    });
                } else {
                    this.$toastr('warning', 'Please select file', 'Warning');
                }
            },
            uploadStudentScore() {
                var formData = new FormData();
                for (var attribute in this.form.upload) {
                    formData.set(attribute, this.form.upload[attribute]);
                }
                this.axios.post(process.env.API_URL + '/tryout/upload-group-score', formData).then(response => {
                    if (response.data.status) {
                        this.modal.upload = false;
                        this.$toastr('success', response.data.message, 'Success');
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            fileStudentScore(event) {
                var input = event.currentTarget;
                if (input.files && input.files[0]) {
                    this.form.upload['group-score'] = input.files[0];
                }
            },
            calculate() {
                this.axios.get(process.env.API_URL + '/tryout/calculate/' + this.tryout.id).then(response => {
                    if (response.data.status) {
                        this.paginate(1);
                        this.$toastr('success', response.data.message, 'Success');
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            score(student, tryoutSubject) {
                var subjectScore = student.subjectScores.find(subjectScore => subjectScore.tryoutSubjectID === tryoutSubject.id);
                return subjectScore ? subjectScore.score : 0;
            },
            paginate(page, scroll = true) {
                this.axios.get(process.env.API_URL + '/tryout/scores/' + this.tryout.id, {params: {page: page}}).then(response => {
                    this.students = response.data.data.data;
                    this.pageCount = response.data.data.total ? response.data.data.last_page : 0;

                    if (scroll) {
                        document.getElementById('table-primary').scrollIntoView();
                        var headerElement = document.getElementsByTagName('nav');
                        if (headerElement.length) {
                            window.scrollBy(0, headerElement[0].offsetHeight * -1);
                        }
                    }
                });
            },
            remove() {
                this.axios.post(process.env.API_URL + '/tryout/delete/' + this.tryout.id).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.$router.push({name: 'tryout/offline/index'});
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                    this.modal.remove = false;
                });
            },
            fetchTryout() {
                this.axios.get(process.env.API_URL + '/tryout/' + this.$route.params.id).then(response => {
                    this.tryout = response.data.data;
                    if (this.tryout.tryoutOnline) {
                        this.$router.replace({name: 'error', params: {code: 404, message: 'Tryout offline not found'}});
                    }

                    var tryoutGroups = this.tryout.tryoutGroups;
                    if (tryoutGroups.length) {
                        for (var i = 0; i < tryoutGroups.length; i++) {
                            this.tryoutSubjects.push(...tryoutGroups[i].tryoutSubjects);
                        }
                        this.paginate(1, false);
                    } else {
                        this.tryoutSubjects = this.tryout.tryoutSubjects;
                    }
                    document.title = 'Tryout Offline ' + this.tryout.name + ' - ' + process.env.APP_NAME;
                }).catch((error) => {
                    this.$router.replace({name: 'error', params: {code: error.response.status, message: error.response.statusText}});
                });
            },
            isMobile() {
                return 'ontouchstart' in window || navigator.msMaxTouchPoints;
            },
            roleElligibleModified() {
                return this.profile.isAdmin;
            }
        },
        created() {
            this.fetchTryout();
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/tryout/offline/View.vue